import withStore from 'store/StoreContainer';

import { supportTicketStatusSelector, createTicket } from 'modules/v2/store';

const mapDispatchToProps = {
  createTicket,
};

const mapStateToProps = (state) => ({
  ticketStatus: supportTicketStatusSelector(state),
});

export default withStore(mapStateToProps, mapDispatchToProps);
